import PropTypes from 'prop-types';
import { useId } from 'react';
import { formatDeadlineDate as formatDeadline } from '@/lib/dateUtils';
import {
  actuationLabel,
  addressTypeLabel,
  conservadorFields,
  recipientLines,
} from '@/lib/taskActuation';
import './SolicitudCotizacionesResumen.css';

export default function SolicitudCotizacionesResumen({ data }) {
  const notesId = useId();
  const recipients = recipientLines(data);
  const rows = [
    ['Causa', [data.rol, data.caratula].filter(Boolean).join(' · ')],
    ['Tribunal', data.tribunalName],
    ['Corte', data.courtName],
    ['Actuación', actuationLabel(data)],
    [
      'Inscripción',
      conservadorFields(data)
        ?.map(([label, value]) => `${label} ${value}`)
        .join(' · '),
    ],
    [
      'Destinatarios',
      recipients.length ? (
        <ul className="solicitud-resumen__list">
          {recipients.map((line, i) => (
            <li key={i}>{line}</li>
          ))}
        </ul>
      ) : null,
    ],
    [
      'Comuna · Región',
      [data.commune, data.region].filter(Boolean).join(' · '),
    ],
    ['Dirección', data.address],
    ['Detalle', data.addressDetails],
    ['Tipo de domicilio', addressTypeLabel(data.addressType)],
    ['Fecha límite', formatDeadline(data.deadline)],
  ].filter(([, value]) => value && (typeof value !== 'string' || value.trim()));

  return (
    <div className="solicitud-resumen">
      <section className="solicitud-resumen__notas" aria-labelledby={notesId}>
        <h4 id={notesId}>Notas para el receptor</h4>
        <p>{data.notes?.trim() ? data.notes : 'Sin notas para el receptor'}</p>
      </section>
      <dl className="confirm-summary">
        {rows.map(([label, value]) => (
          <div className="confirm-summary__row" key={label}>
            <dt>{label}</dt>
            <dd>{value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

SolicitudCotizacionesResumen.propTypes = {
  data: PropTypes.shape({
    rol: PropTypes.string,
    caratula: PropTypes.string,
    tribunalName: PropTypes.string,
    courtName: PropTypes.string,
    commune: PropTypes.string,
    region: PropTypes.string,
    address: PropTypes.string,
    addressDetails: PropTypes.string,
    deadline: PropTypes.string,
    notes: PropTypes.string,
    actuationType: PropTypes.string,
    actuationTypeOther: PropTypes.string,
    conservador: PropTypes.object,
    addressType: PropTypes.string,
    recipients: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};
